// Import dependencies
import initialiser from '../../utils/initialiser';

class Expandable {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.container = el;
    this.button = el.querySelector(settings.button);
    this.contentPanel = el.querySelector(settings.contentPanel);

    // Set settings
    this.settings = settings;
  }

  // Initialisation Function
  init = () => {
    if (!this.container || !this.button || !this.contentPanel) return;
    this.button.addEventListener('click', this.bindEvents);
  };

  // Bind module events
  bindEvents = () => {
    this.updateBtnAriaAttributes();
    this.updatePanelAriaAttributes();
    this.togglePanel();
    this.setPanelHeight();
  };

  updateBtnAriaAttributes = () => {
    const btnariaValue = this.button.getAttribute('aria-expanded');
    const newAriaValue = btnariaValue === 'true' ? 'false' : 'true';
    this.button.setAttribute('aria-expanded', newAriaValue);
    this.button.setAttribute('aria-selected', newAriaValue);
  };

  updatePanelAriaAttributes = () => {
    const panelAriaValue = this.contentPanel.getAttribute('aria-hidden');
    const newAriaValue = panelAriaValue === 'false' ? 'true' : 'false';
    this.contentPanel.setAttribute('aria-hidden', newAriaValue);
  };

  togglePanel = () => {
    this.container.classList.toggle(this.settings.openClass);
    return false; // prevent form from submitting
  };

  setPanelHeight = () => {
    this.contentPanel.style.height = this.contentPanel.style.height ? null : `${this.contentPanel.scrollHeight}px`;
  };
}

export default settings => initialiser(settings, Expandable);
